export default {"src":"/_next/static/media/charge_phone.d702e9b8.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};